import { object, string, number, array } from 'yup'
import { t } from 'ttag'

import {
  DESCRIPTION_FIELD,
  LANGUAGES_FIELD,
  POSITION_FIELD,
  AMOUNT_FIELD,
  DEPARTMENT_FIELD,
} from './model'

export const POSITION_FIELD_LIMIT = 100

export const getSchema = isPositionManagement =>
  object().shape({
    [POSITION_FIELD]: string()
      .max(
        POSITION_FIELD_LIMIT,
        t`Position title cannot exceed 100 characters.`,
      )
      .required(t`This field cannot be empty.`),
    [DEPARTMENT_FIELD]: object()
      .shape({ label: string(), value: string() })
      .required(t`This field cannot be empty.`),
    [LANGUAGES_FIELD]: array()
      .of(object().shape({ label: string(), value: string() }))
      .min(1, t`This field cannot be empty.`)
      .required(t`This field cannot be empty.`),
    [DESCRIPTION_FIELD]: string(),
    ...(isPositionManagement && {
      [AMOUNT_FIELD]: number()
        .typeError(t`This field cannot be empty.`)
        .min(1, t`Number can't be less than 1.`)
        .required(t`This field cannot be empty.`),
    }),
  })
